import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const PageFooter = ({ portfolio }) => {
  const portfolioId = portfolio.initialPortfolioId
    ? portfolio.initialPortfolioId
    : portfolio.uuid;
  return (
    <section className="page-footer">
      <Grid container={true}>
        <Grid item xs={4}>
          <Typography variant={"caption"} paragraph>
            {portfolio.name}
            <br />
            {portfolio.onboardStatus !== "in-review" && portfolioId}
          </Typography>
        </Grid>
        <Grid item xs={4} style={{ textAlign: "center" }}>
          <Typography variant={"caption"} paragraph>
            Document Serial Number
            <br />
            {portfolio.documentSN}
          </Typography>
        </Grid>
        <Grid item xs={4} style={{ textAlign: "right" }}>
          <Typography variant={"caption"} paragraph>
            Portfolio Summary
            <br />
            <span className={"pageIndex"} /> of{" "}
            <span className={"totalPages"} />
          </Typography>
        </Grid>
      </Grid>
    </section>
  );
};

export default PageFooter;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/PageFooter.jsx